import { DEFAULT_ICON_OPACITY, DEFAULT_ICON_SIZE } from 'app-constants';
import { memo } from 'react';

import type { AppIconProps } from '../app-icon.types';

export const EnglishFlagIcon = memo(
  ({
    size = DEFAULT_ICON_SIZE,
    opacity = DEFAULT_ICON_OPACITY,
  }: AppIconProps) => {
    const { width, height } = size;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
      >
        <circle cx="9" cy="9" r="9" fill="#012169" />
        <g opacity={opacity} clipPath="url(#clip0_1691_5025)">
          <path d="M0 0H18V18H0V0Z" fill="#012169" />
          <path
            d="M18.7041 -0.703125V1.125L10.8862 9L18.2822 16.3103V18.2812H16.3684L8.94385 10.9424L1.2666 18.6768H-0.675781V16.7344L7.00146 9.02856L-0.284668 1.82812V-0.285645H1.48633L8.94385 7.05762L16.6475 -0.703125H18.7041Z"
            fill="white"
          />
          <path
            d="M6.46875 11.3906L6.85547 12.5859L1.47656 18H0V17.8945L6.46875 11.3906ZM10.8281 10.9688L12.7266 11.25L18 16.418V18L10.8281 10.9688ZM18 0L11.25 6.89062L11.1094 5.34375L16.3828 0H18ZM0 0.0351562L6.78516 6.67969L4.71094 6.39844L0 1.72266V0.0351562Z"
            fill="#C8102E"
          />
          <path
            d="M6.1875 0V18H11.8125V0H6.1875ZM0 6.1875V11.8125H18V6.1875H0Z"
            fill="white"
          />
          <path
            d="M0 7.3125V10.6875H18V7.3125H0ZM7.3125 0V18H10.6875V0H7.3125Z"
            fill="#C8102E"
          />
        </g>
        <defs>
          <clipPath id="clip0_1691_5025">
            <circle cx="9" cy="9" r="9" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
